import React from 'react';
import { number } from 'prop-types';

export default function ResultCount({ count }) {
    const message = `item${count > 1 ? 's' : ''} found`;

    return (
        <div className="result-count">
            <span>{`${count} ${message}`}</span>
        </div>
    );
}

ResultCount.propTypes = { count: number.isRequired };
